import FeeSchedule from "./feeSchedule";
import { DateRange, NameIdPair, User } from "./misc";
import { RequestPurpose } from "./requestType";
import { Facility } from "../components/dataEntryDetails/dataEntryComponents/DataEntryDetails";

export enum SensitiveInfoType {
    GeneticInformation = 1,
    HivAids = 2,
    MentalHealth = 3,
    SubstanceAbuse = 4,
    Std = 5,
}

export enum SensitiveInfoRelease {
    Prohibited = 0,
    Authorized = 1,
    NotMentioned = 2,
}

export interface SensitiveInfo {
    readonly id: SensitiveInfoType,
    readonly name: string,
    readonly stateID: SensitiveInfoRelease
}

export interface Release {
    readonly id: number,
    readonly name: string,
    /**
     * @deprecated duplicate of `id`
     */
    readonly requestedItemID: number,
    readonly code: string,
    readonly checked: boolean,
    readonly allDates: boolean,
    readonly dateOfService?: DateRange,
    /**
     * @deprecated duplicate of `TransactionDetails.requestComments` that is
     * only present if `id` is 31
     */
    readonly comment?: string,
}

/** The only record type with a free-text box (InfoToRelease's own `hasFreeText`). */
export const OTHER_DOCUMENTS_RELEASE_ID = 31;

export interface TransactionDetails {
    docAIProcessID?: string,
    docAIStatusID?: string,
    /**
     * The request buffer ID
     */
    id: number,
    facility: Facility,
    patient?: NameIdPair<number>,
    sendToRequestor?: NameIdPair<number>,
    sendToContact?: NameIdPair<number>,
    billToRequestor?: NameIdPair<number>,
    billToContact?: NameIdPair<number>,
    requestPurpose?: RequestPurpose,
    date: any,
    /**
     * @deprecated This is always the same as requestID
     */
    externalRequestID: string,
    caseNumber: string,
    requestForAuditType: number,
    onBehalfOf: number,
    mrn: string,
    /**
     * @deprecated
     */
    certificationRequired?: boolean
    transactionNotes: any[],
    deliveryInstructions: string,
    feeSchedule?: FeeSchedule,
    shippingService: string,
    readonly sensitiveInfo: readonly SensitiveInfo[],
    readonly releaseInfo: readonly Release[],
    requestComments: string,
    releaseMethod?: NameIdPair<number>,
    transactionStatus: NameIdPair<number>,
    invoiceAmount: number,
    paidAmount: number,
    payments: any[],
    accessCode: string,
    disclosingInstitution?: NameIdPair<number>,
    disclosure?: any,
    requestID: string,
    /**
     * @deprecated same as sendToRequestor.id
     */
    requestorNameID?: number,
    billingTypeID: number,
    includeRequestPages?: boolean,
    includeAuxilliaryPages?: boolean,
    postageIsApplied: string,
    /**
     * @deprecated
     */
    prePay: boolean,
    transactionDds: any,
    /**
     * @deprecated Use requestPurpose
     */
    transactionRequest: any,
    isReadOnly: boolean,
    lockedBy?: User,
    transactionWaitHold: any[],
    transactionHoldReason?: string,
    isEscalated: boolean,
    certificationTypeId?: string,
    tableID: number,
    isInAIProcessing: boolean,
    aiProcessingCompleted: boolean,
    aiProcessingFailed: boolean,
}

export interface ReleaseInfoUpdate {
    readonly organizationId: number,
    readonly requestBufferId: number,
    readonly releases: readonly number[],
    readonly from?: Date,
    readonly to?: Date,
    readonly requestComments?: string,
}

interface SensitiveInfoEntry {
    readonly model: string,
    readonly id: number,
    readonly name: string
    readonly stateID: number,
    readonly label: string,
    readonly state: string,
}

export interface SensitiveInfoUpdateAPI {
    UpdatePayload: {
        type: string,
        data: {
            readonly transactionId: string,
            readonly userID: number,
            readonly geneticSensitiveInfo: number,
            readonly hivAidsSensitiveInfo: number,
            readonly mentalHealthSensitiveInfo: number,
            readonly substanceAbuseSensitiveInfo: number,
            readonly sexuallyTransmittedDiseaseSensitiveInfo: number,
        }
        update: boolean,
    }

    readonly InfoList: SensitiveInfoEntry[]
}


